import { RuleProps } from "types/application";

export const TWICL_QUALIFICATION_DETAILS = 'twicl-qualification-details';
export const TWICL_INITIAL_DETAILS = 'twicl-initial-details';
export const TWICL_END_DETAILS = 'twicl-end-details';

export const TWICL_APPLICATION = [
    {
        sectionID: TWICL_INITIAL_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'service-provided',
                label: 'Service Provided',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: TWICL_QUALIFICATION_DETAILS,
        sectionName: 'Qualification Details',
        fieldList: [
            {
                id: 'institution',
                label: 'Institution',
                type: 'text'
            },
            {
                id: 'certificate-number',
                label: 'Certificate Number',
                type: 'text'
            },
            {
                id: 'other-institution-name',
                label: 'Other Institution',
                type: 'text',
                span: 12
            },
            {
                id: 'course-name',
                label: 'Course Name',
                type: 'text'
            },
            {
                id: 'completion-date',
                label: 'Completion Date',
                type: 'text'
            },
            {
                id: 'other-course-name',
                label: 'Other Course Name',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: TWICL_END_DETAILS,
        sectionName: 'Supporting Documents',
        rule: {
            baseIds: [`${TWICL_END_DETAILS}-proof-of-certificate`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues && baseValues[`${TWICL_END_DETAILS}-proof-of-certificate`] === '-'
                );
                return result;
            }
        },
        fieldList: [
            {
                id: 'proof-of-certificate',
                label: 'Proof Of Certificate',
                type: 'text',
                span: 12
            }
        ]
    },
];
